/** Hydrate authored option controls and publish the matching product variant. */
if (!customElements.get("ai-variant-selector")) {
  customElements.define("ai-variant-selector", class VariantSelector extends HTMLElement {
    connectedCallback() {
      const product = this.closest("ai-product-detail");
      try {
        this._variants = JSON.parse(product?.querySelector("[data-product-variants]")?.textContent || "[]");
      } catch {
        this._variants = [];
      }
      this._groups = Array.from(this.querySelectorAll("[data-product-option]"));
      this._boundClick ||= event => {
        const button = event.target.closest('button[data-product-option-value]');
        if (!button || button.closest("ai-variant-selector") !== this || button.disabled) return;
        const group = button.closest("[data-product-option]");
        for (const control of group.querySelectorAll('button[data-product-option-value]')) {
          control.setAttribute("aria-pressed", String(control === button));
        }
        this._publishSelection();
      };
      this._boundChange ||= event => {
        if (event.target.closest("ai-variant-selector") !== this) return;
        if (event.target.matches('input[data-product-option-value], select[data-product-option-values]')) this._publishSelection();
      };
      this.addEventListener("click", this._boundClick);
      this.addEventListener("change", this._boundChange);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this._boundClick);
      this.removeEventListener("change", this._boundChange);
    }

    _publishSelection() {
      const selected = this._groups.map(group => {
        const controls = Array.from(group.querySelectorAll("[data-product-option-value]"));
        const choice = controls.find(control => control.matches('button[aria-pressed="true"], input:checked, option:checked'));
        return choice?.getAttribute("data-product-option-value");
      });
      const variant = this._variants.find(candidate => candidate.options?.length === selected.length
        && candidate.options.every((value, index) => String(value) === selected[index])) || null;
      this.setAttribute("selected-variant-id", variant ? String(variant.id) : "");
      this.dispatchEvent(new CustomEvent("variant:change", {
        bubbles: true,
        detail: { variantId: variant?.id ?? null, variant, available: Boolean(variant?.available) },
      }));
    }
  });
}
